<div class="content">
  <video id="singleVideo" preload="auto" controls>
    <source [src]="data.toView" type="video/mp4" />
    Your browser does not support the video tag.
  </video>
</div>
